import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { TVulnerabilityCodeLine, TVulnerabilityDetails } from '../../models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilityCodeBlock',
  props: {
    vulnerability: null,
    block: null
  },
  setup(__props: any) {

const props = __props as {
  vulnerability: TVulnerabilityDetails;
  block: {
    file: string;
    lines: Array<{ line_number: number; content: string; is_matched: boolean }>;
    minSpaces: number;
    source_type: string;
  };
};



const MIN_SPACES_BEFORE_CODE = '   ';

const severity = computed(() => props.vulnerability.category.severity || null);

function getSeverityLineClass(sev: string | undefined): string {
  if (sev === 'low') return 'tw:bg-vuln-low';
  if (sev === 'medium') return 'tw:bg-vuln-medium';
  if (sev === 'high') return 'tw:bg-vuln-high';

  return 'tw:bg-[lightgrey]';
}

function getHighlightedLineClass(line: TVulnerabilityCodeLine): string {
  return line.is_matched ? 'tw:bg-[#feeae7]' : '';
}

function getHighlightLanguageBySourceType(sourceType: string): string {
  return ['xml', 'java', 'swift'].find((lang) => lang === sourceType) ?? 'plaintext';
}

return { __sfc: true,props, MIN_SPACES_BEFORE_CODE, severity, getSeverityLineClass, getHighlightedLineClass, getHighlightLanguageBySourceType }
}

})